// Components
import DatePicker from "vue2-datepicker";

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js";
import { dateMixins } from "@/app/mixins/utils/date-mixins";

// Services
import TreatmentService from "@/app/services/main/treatment/treatment-service";
import { STATUS_CODES } from "@/app/constants/constants";

// Constants
import { FORMAT_TEXT } from "@/app/constants/format-text-constants";

// Events
import EventBus from "@/app/bus/event-bus.js";

let preFilterData;
export default {
    name: "TreatmentsManagementContainer",
    components: {
        DatePicker,
    },
    mixins: [tableMixins, toastMessageMixins, dateMixins],
    data() {
        const statusList = [
            {
                id: "ACTIVE",
                name: "Active",
            },
            {
                id: "INACTIVE",
                name: "Inactive",
            },
        ];

        return {
            isAPILoading: false,
            // table
            theads: [
                { name: "Brand", searchLabel: "f_brand", sortLabel: "brand", isDesc: false, hasSearch: true },
                {
                    name: "Product",
                    searchLabel: "f_name",
                    sortLabel: "name",
                    isDesc: false,
                    hasSearch: true,
                    style: null,
                },
                {
                    name: "Date Added",
                    searchLabel: "f_dateAdded",
                    sortLabel: "dateAdded",
                    isDesc: false,
                    hasDate: true,
                    style: null,
                },
                { name: "Owner", searchLabel: "f_ownerName", sortLabel: "ownerName", isDesc: false, hasSearch: true },
                {
                    name: "Owner Email",
                    searchLabel: "f_ownerEmail",
                    sortLabel: "ownerEmail",
                    isDesc: false,
                    hasSearch: true,
                    style: null,
                },
                { name: "Pet", searchLabel: "f_petName", sortLabel: "petName", isDesc: false, hasSearch: true },
                {
                    name: "Status",
                    searchLabel: "f_status",
                    sortLabel: "status",
                    isDesc: false,
                    hasSearchableDropdown: true,
                    optionList: statusList,
                },
                { name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null },
            ],
            // sorting
            desc: true,
            selectDateAdded: "",
            filterValues:{}
        };
    },
    computed: {
        getFromUsersFilter() {
            return this.$store.getters.getFromUsersFilter;
        },
        isPreFilterMode() {
            return this.$store.getters.getTreatmentPreFilterMode;
        },
    },
    async created() {
        await EventBus.$on("treatments", async (data) => {
            preFilterData = data;
            EventBus.$off("treatments", () => {});
        });
        this.setPreFilters();
        this.loadSavedFilters();
        this.getTableContent(false);
    },
    mounted() {
        // this.setPreFilters('mounted');
    },
    beforeDestroy() {
        this.$store.commit("setTreatmentPreFilterMode", false);
        this.$store.commit("clearFromUsersFilter");
    },
    watch: {
        selectDateAdded() {
            this.getTableContent(true);
        },
    },
    activated() {
        // this lifecycle method will only be called for components under keep-alive
        // this.getTableContent();
	},
    methods: {
        handleClick(treatment) {
            this.saveAllFilters()
           this.$router.push({
                path: '/notifications/send',
                query: {
                    id: treatment.owner.id,
                    name: encodeURIComponent(treatment.owner.email),
                    fullName: treatment.owner.name,
                    actionFrom: 'treatment'
                }
            });
        },
        onSubsFilter(filterBy, value) {
			if (filterBy) {
				this.page = 1;
				this.columnsFilter[filterBy] = value;
                this.filterValues[filterBy] = value;
				this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc);
			}
		},
        onColumnSubsFilter(filterBy, event) {
			if (filterBy) {
				this.page = 1;
                this.columnsFilter[filterBy] = event.target.value;
                this.filterValues[filterBy] = event.target.value;
				this.delayTyping(() => {
					this.getTableContent(false, this.page, this.limit, this.sortBy, this.desc);
				});
			}
		},
        clearFilters() {
            const filters = this.$store.state.treatmentFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0; 
            if (hasFilters) {
                this.$store.dispatch('resetTreatmentFilters');
            }
        },
       
        saveAllFilters() {
            const filters = {};
                // Collect all the column filter values
                this.theads.forEach(th => {
                    if (th.hasDate) {
                        filters[th.sortLabel] = this.formatDate(this.selectDateAdded, "yyyy-MM-dd HH:mm");
                    } else {
                        const searchInput = this.columnsFilter[`${th.searchLabel}`];
                        if (searchInput) {
                            filters[th.sortLabel] = searchInput;
                        }
                    }
                });

                // Add pagination details to filters
                filters.page = this.page; // current page
                filters.limit = this.limit; // items per page
                // Dispatch all filters, including pagination, to Vuex store
                Object.keys(filters).forEach(label => {
                    this.$store.dispatch('applyTreatmentFilter', { label, value: filters[label] });
                });
          },          
          loadSavedFilters() {
            const filters = this.$store.state.treatmentFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0;
            if (hasFilters) {
                
                // You can access the saved filter values from the store like this:
                this.theads.forEach(th => {
                    const savedFilter = this.$store.getters.getTreatmentFilter(th.sortLabel);

                    if (savedFilter) {
                        this.columnsFilter[th.searchLabel] = savedFilter;
                        if (th.hasDate) {
                            this.filterValues[th.searchLabel] = savedFilter
                            this.selectDateAdded = new Date(savedFilter)
                        } else {
                            this.filterValues[th.searchLabel] = savedFilter
                        }
                    }
                }); 

                this.page = this.$store.getters.getTreatmentFilter('page') || 1;
                this.limit = this.$store.getters.getTreatmentFilter('limit') || 10; 
        
                this.clearFilters()
            }
        },      
        formatText(text) {
            return FORMAT_TEXT[text] ? FORMAT_TEXT[text] : text;
        },
        setPreFilters() {
            if (this.isPreFilterMode) {
                const { emailAddress, petName } = this.getFromUsersFilter;

                this.columnsFilter["f_ownerEmail"] = emailAddress;
                this.columnsFilter["f_petName"] = petName;
                this.$refs.filter_ownerEmail[0].value = emailAddress;
                this.$refs.filter_petName[0].value = petName;
            }
        },
        getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
            this.getSubscriptionsList({ page, limit, sortBy, desc });
        },
        getSubscriptionsList(queryParams) {
            this.isAPILoading = true;

            if (this.columnsFilter) {
                const { f_brand, f_name, f_ownerName, f_ownerEmail, f_petName, f_status } = this.columnsFilter;

                if (f_brand) {
                    queryParams["f_brand"] = f_brand;
                }

                if (f_name) {
                    queryParams["f_name"] = f_name;
                }

                if (f_ownerName) {
                    queryParams["f_ownerName"] = f_ownerName;
                }

                if (f_ownerEmail) {
                    queryParams["f_ownerEmail"] = f_ownerEmail;
                }

                if (f_petName) {
                    queryParams["f_petName"] = f_petName;
                }

                if (f_status) {
                    queryParams["f_status"] = f_status;
                }

                if (this.selectDateAdded) {
                    queryParams["f_dateAdded"] = this.formatDate(this.selectDateAdded, "yyyy-MM-dd HH:mm");
                }
            }

            TreatmentService.getTreatmentList(queryParams).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.tableContent = {
                        tableData: res.data.data,
                        paginationData: res.data.pagination,
                    };

                    if (this.isPreFilterMode) {
                        this.$store.commit("setTreatmentPreFilterMode", false);
                    }
                } else {
                    const { ERROR_GET_TREATMENT_LIST } = this.toastMessages.treatment();

                    this.showAPIErrorToast(ERROR_GET_TREATMENT_LIST, res);
                }
                this.isAPILoading = false;
            });
        },
    },
};
